import React from 'react';
import Icons, { fontello_icon_names } from './icons'

export const icon_list = fontello_icon_names;

export default ({ onPress, ...props }) => {
	return (<Icons {...props} />);
}